<template>
    <v-card>
        <v-card-title>
            <v-flex xs12 sm6>
                <div class="headline">Bancas presididas</div>
            </v-flex>
            <v-flex xs12 sm5>
                <v-text-field
                        append-icon="search"
                        label="Pesquisar"
                        single-line
                        hide-details
                        v-model="search"></v-text-field>
            </v-flex>
        </v-card-title>
        <v-card-title>
            <exam-filters v-model="filters" :options="['semester', 'course']" :can-select-any-course="true" :semester-required="true"></exam-filters>
        </v-card-title>
        <v-card-actions v-if="auth.user.roles.includes('admin')">
            <router-link :to="{ name: 'examRecord' }" >
                <v-btn color="info" dark title="Registrar banca finalizada de modo manual">
                    <v-icon left light>description</v-icon> Registrar banca finalizada (manual)
                </v-btn>
            </router-link>
        </v-card-actions>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            :no-data-text="noData"
            :no-results-text="noResult"
            :rows-per-page-text="rowsPerPageT"
            class="elevation-1">
            <template slot="items" slot-scope="props">
                <tr :class="getExamRowClass(props.item)">
                    <td>{{ props.item.id }}</td>
                    <td>
                        <p v-for="item in props.item.studentName">{{ item }}</p>
                    </td>
                    <!-- <td>{{ props.item.title }}</td> -->
                    <td>{{ props.item.date | moment('DD/MM/YYYY') }}</td>
                    <td>{{ props.item.hour }}</td>
                    <td>{{ props.item.place }}</td>
                    <td>
                        <v-chip small :class="[getExamStatusClass(props.item), 'white--text']">
                            {{ getExamStatus(props.item) }}
                        </v-chip>
                    </td>
                    <td>
                        <v-btn color="orange" floating small dark fab title="Registrar e certificar presença dos participantes" @click.stop="showExamAttendance(props.item)">
                            <v-icon dark>playlist_add_check</v-icon>
                        </v-btn>
                        <v-btn color="cyan darken-1" floating small dark fab title="Ver fichas de avaliação" @click.stop="showExamEvaluation(props.item)">
                            <v-icon dark>gavel</v-icon>
                        </v-btn>
                        <router-link :to="{ name: 'examDetail', params: { id: props.item.id } }" v-if="!props.item.finalScore || props.item.finalScore == 0">
                            <v-btn color="success" floating small dark fab title="Encerrar banca">
                                <v-icon dark>school</v-icon>
                            </v-btn>
                        </router-link>
                        <router-link :to="{ name: 'examDetail', params: { id: props.item.id } }" v-if="props.item.finalScore > 0">
                            <v-btn color="info" floating small dark fab title="Ver banca">
                                <v-icon dark>description</v-icon>
                            </v-btn>
                        </router-link>
                        <v-btn color="grey darken-2" floating small dark fab title="Emitir documentos" @click.stop="showExamDocuments(props.item)">
                            <v-icon dark>folder</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-card-text>
            <p class="pa-1 mb-0">Acima estão listadas as bancas que você participa como presidente.</p>
            <p class="green lighten-4 pa-1 mb-0">Bancas realizadas hoje são exibidas com destaque <strong class="green--text">verde</strong>.</p>
        </v-card-text>
        <fullscreen-spinner></fullscreen-spinner>
        <v-dialog v-model="evaluationDialog" fullscreen lazy>
            <exam-evaluations :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="evaluationDialog = false">Fechar</v-btn>
                </template>
            </exam-evaluations>
        </v-dialog>
        <v-dialog v-model="attendanceDialog" fullscreen lazy>
            <exam-attendance :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="attendanceDialog = false">Fechar</v-btn>
                </template>
            </exam-attendance>
        </v-dialog>
        <v-dialog v-model="documentsDialog" fullscreen lazy>
            <exam-documents :exam-id="selectedExam">
                <template slot="actions">
                    <v-spacer></v-spacer>
                    <v-btn color="info" @click="documentsDialog = false">Fechar</v-btn>
                </template>
            </exam-documents>
        </v-dialog>
    </v-card>
</template>

<script>
    import { noData, noResult, rowsPerPageT } from './../locale/vuetify';
    import auth from './../auth'
    import ExamEvaluations from './ExamEvaluations.vue'
    import ExamAttendance from './ExamAttendance.vue'
    import ExamDocuments from './ExamDocuments.vue'
    import ExamFilters from './ExamFilters.vue'

    export default {
        name: 'ExamChairList',
        components: {
            ExamEvaluations,
            ExamAttendance,
            ExamDocuments,
            ExamFilters
        },
        data() {
            return {
                headers: [
                    { text: 'Id', align: 'left', value: 'id' },
                    { text: 'Aluno', align: 'left', value: 'studentName' },
                    /*{ text: 'Título', align: 'left', value: 'title' },*/
                    { text: 'Data', align: 'left', value: 'date' },
                    { text: 'Hora', align: 'left', value: 'hour' },
                    { text: 'Local', align: 'left', value: 'place' },
                    { text: 'Situação', align: 'left', value: 'status' },
                    //{ text: 'Examinadores', align: 'left', value: 'examinersName' },
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                items: [],
                totalItems: -1,
                search: '',
                pagination: {
                    rowsPerPage: 10,
                    sortBy: 'date',
                    descending: false
                },
                loading: false,
                noData: noData,
                noResult: noResult,
                rowsPerPageT: rowsPerPageT,
                filters: {},
                selectedExam: null,
                evaluationDialog: false,
                attendanceDialog: false,
                documentsDialog: false,
                auth: auth
            }
        },
        watch: {
            pagination: {
                handler() {
                    this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
                },
                deep: true
            },
            filters: {
                handler() {
                    this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
                },
                deep: true
            }
        },
        methods: {
            mountSearchString() {
                let searchString = this.search
                for (let key in this.filters) {
                    let value = this.filters[key]
                    if (!!value && key != 'view') {
                        searchString = '['+key+'='+value+']' + searchString
                    }
                }
                return searchString
            },
            getDataFromApi() {
                this.loading = true
                return new Promise((resolve, reject) => {
                    const { sortBy, descending, page, rowsPerPage } = this.pagination
                    let offset = 0;
                    if (rowsPerPage > 0) offset = (page - 1) * rowsPerPage
                    const params = {
                        search: this.mountSearchString(),
                        view: 'chair',
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        limit: rowsPerPage,
                        offset: offset
                    }
                    this.$http.post('exams', params).then(response => {
                        this.loading = false
                        const items = response.body
                        const total = parseInt(response.headers.get('X-Pagination-Total-Count'))
                        resolve( { items, total })
                    }, response => {
                        console.error('Erro ao carregar as bancas do servidor.')
                        console.log(response)
                    })
                })
            },
            getEvaluationStatus(evaluation) {
                let status = 'Avaliação pendente'
                if (evaluation != null) {
                    if (typeof evaluation.start !== 'undefined' && evaluation.start != null) {
                        status = 'Avaliação iniciada' // em ' + evaluation.start
                        if (evaluation.finish != null) {
                            status = 'Avaliação finalizada' // em ' + evaluation.finish
                        }
                    }
                }
                if (status == 'Avaliação pendente') {
                    let examDate = this.getExamDate(exam),
                        now = new Date()
                    if (examDate.toISOString().substr(0, 10) < now.toISOString().substr(0, 10)) {
                        status = 'Avaliação atrasada'
                    }
                }
                return status
            },
            getExamStatus(exam) {
                let pending = 0,
                    started = 0,
                    finished = 0,
                    all = 0,
                    examiners = new Set(exam.substitutes.concat(Object.keys(exam.evaluations || {}))),
                    status = 'Avaliação pendente'
                all = examiners.length
                if (exam.finalScore > 0) {
                    status = 'Banca finalizada'
                } else {
                    for (let examiner in examiners) {
                        evaluation = exam.evaluations[key]
                        let status = this.getEvaluationStatus(evaluation)
                        if (status == 'Avaliação pendente' || status == 'Avaliação atrasada') {
                            pending++
                        } else if (status == 'Avaliação iniciada') {
                            started++
                        } else if (status == 'Avaliação finalizada') {
                            finished++
                        }
                        if (pending + started + finished > 0 && pending < all) {
                            if (finished == all) {
                                status = 'Aguardando decisão'
                            } else {
                                status = []
                                if (pending > 0)    status.push(pending + ' avaliações pendentes')
                                if (started > 0)    status.push(started + ' avaliações em andamento')
                                if (finished > 0)   status.push(finished + ' avaliações concluídas')
                                status = status.join(', ')
                            }
                        }
                    }
                }
                return status
            },
            getExamStatusClass(exam) {
                let status = this.getExamStatus(exam)
                if (status == 'Avaliação pendente') return 'info';
                if (status == 'Aguardando decisão') return 'warning';
                if (status == 'Banca finalizada') return 'success';
                return 'grey darken-2'
            },
            getExamDate(exam) {
                return new Date(exam.date + 'T' + exam.hour + ':00')
            },
            getExamRowClass(exam) {
                let examDate = this.getExamDate(exam),
                    examFinishDate = (examDate.getTime() + (30 * 60 * 1000)),
                    now = new Date(),
                    classes = []
                if (isNaN(examDate.getTime())) return []
                if (examDate <= now && examFinishDate >= now) {
                    classes.push('green lighten-2')
                } else if (examDate.getDate() == now.getDate() && examDate.getMonth() == now.getMonth() && examDate.getFullYear() == now.getFullYear()) {
                    classes.push('green lighten-4')
                }
                return classes
            },
            showExamEvaluation(exam) {
                this.selectedExam = exam.id
                this.evaluationDialog = true
            },
            showExamAttendance(exam) {
                this.selectedExam = exam.id
                this.attendanceDialog = true
            },
            showExamDocuments(exam) {
                this.selectedExam = exam.id
                this.documentsDialog = true
            }
        },
        mounted() {
            this.getDataFromApi().then(data => { this.items = data.items; this.totalItems = data.total; })
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// ExamChairList.vue?7e1d508c